module.exports = __webpack_public_path__ + "img/banner.7373c26c.png";